(ns common.entity-name
    (:require [clojure.string :as string]
              [common.data-types :as data-types]
              [common.schema.entities.pre-exit-check :as pre-exit-check]
              [common.schema.entities.pre-investment-check :as pre-investment-check]
              [common.schema.entities.task-type :as task-type]))

(defn entity-name
  [entity-lookup tr entity]
  (let [e-type (:entity/type entity)]
    (if (nil? e-type)
      entity
      (case e-type
        :entity.type/workspace (:workspace/name entity)
        :entity.type/check-list (:check-list/label entity)
        :entity.type/account
        (let [name-str (string/trim
                         (string/join " "
                                      [(:account/first-name entity)
                                       (:account/last-name entity)]))]
          (if (empty? name-str)
            (string/trim (str (:account/email entity)))
            name-str))
        :entity.type/attachment (:attachment/filename entity)
        :entity.type/contact-list (:contact-list/title entity)
        :entity.type/company (:asset/name entity)
        :entity.type/real-estate (:asset/name entity)
        :entity.type/fof-asset (:asset/name entity)
        :entity.type/other-asset (:asset/name entity)
        :entity.type/email (:email/subject entity)
        :entity.type/oppo (:oppo/name entity)
        :entity.type/person (let [name-str (string/trim
                                             (string/join " "
                                                          [(:person/first-name entity)
                                                           (:person/last-name entity)]))]
                              (if (empty? name-str)
                                (string/trim (str (:person/universal-email-address entity)))
                                name-str))
        :entity.type/role (tr (:role/role entity))
        :entity.type/stage (:stage/name entity)
        :entity.type/opportunity-stage (:opportunity-stage/name entity)
        :entity.type/sales-opportunity-stage (:sales-opportunity-stage/name entity)
        :entity.type/exit-opportunity-stage (:exit-opportunity-stage/name entity)
        :entity.type/task (task-type/get-label (:task/type entity))
        :entity.type/tenant (:tenant/name entity)
        :entity.type/named-value (:named-value/value entity)
        :entity.type/named-view (:named-view/name entity)
        :entity.type/view (:view/name entity)
        :entity.type/token (:token/type entity)
        :entity.type/fund-commitment "TODO"
        :entity.type/fundraising-opportunity (:fundraising-opportunity/opportunity-name entity)
        :entity.type/sales-opportunity (:sales-opportunity/name entity)
        :entity.type/sale-agreement (:sale-agreement/name entity)
        :entity.type/exit-opportunity (:exit-opportunity/name entity)
        :entity.type/graph-company (:graph-entity/label entity)
        :entity.type/graph-config (:graph-config/name entity)
        :entity.type/graph-person (:graph-entity/label entity)
        :entity.type/graph-fof-asset (:graph-entity/label entity)
        :entity.type/graph-fund (:graph-entity/label entity)
        :entity.type/holding (:holding/name entity)
        :entity.type/kpi-category (:kpi-category/name entity)
        :entity.type/fullcontact-company-common (:fullcontact-company-common/name entity)
        :entity.type/fullcontact-person-common (:fullcontact-person-common/full-name entity)
        :entity.type/team (:team/name entity)
        :entity.type/fund (:fund/name entity)
        :entity.type/investor (:investor/name entity)
        :entity.type/pipeline (:pipeline/name entity)
        :entity.type/kyc-profile (let [target-id (:kyc-profile/target entity)
                                       target (entity-lookup target-id)
                                       target-name (entity-name entity-lookup tr target)]
                                   (if target-name
                                     (str target-name "'s " (tr :entity.type/kyc-profile))
                                     (tr :entity.type/kyc-profile)))
        :entity.type/tenant-kyc-profile (let [target-id (:tenant-kyc-profile/target entity)
                                              target (entity-lookup target-id)
                                              target-name (entity-name entity-lookup tr target)]
                                          (if target-name
                                            (str target-name "'s " (tr :entity.type/tenant-kyc-profile))
                                            (tr :entity.type/tenant-kyc-profile)))
        :entity.type/contract-kyc-profile (let [target-id (:contract-kyc-profile/target entity)
                                                target (entity-lookup target-id)
                                                target-name (entity-name entity-lookup tr target)]
                                            (if target-name
                                              (str target-name "'s " (tr :entity.type/contract-kyc-profile))
                                              (tr :entity.type/contract-kyc-profile)))
        :entity.type/kyc-risk-category (:kyc-risk-category/name entity)
        :entity.type/entity-association (let [target (:entity-association/target-entity entity)
                                              source (:entity-association/source-entity entity)
                                              target-entity (entity-lookup target)
                                              source-entity (entity-lookup source)]
                                          (str (entity-name entity-lookup tr target-entity)
                                               " - "
                                               (entity-name entity-lookup tr source-entity)))
        :entity.type/risk-holding (tr :risk-display-string [(:risk/title entity)])
        :entity.type/liability (tr :liability-display-string
                                   [(:liability/description entity)])
        :entity.type/calculated-indirect-holding (let [fund-id (:indirect-holding/fund entity)
                                                       fund (entity-lookup fund-id)
                                                       target-id (:indirect-holding/holding-target entity)
                                                       target-asset (entity-lookup target-id)]
                                                   (str (entity-name entity-lookup tr fund)
                                                        " / "
                                                        (entity-name entity-lookup tr target-asset)))
        :entity.type/survey-type (:survey-type/label entity)
        :entity.type/survey-template (:survey-template/label entity)
        :entity.type/survey-block (:survey-block/label entity)
        :entity.type/insider-group (:insider-group/name entity)
        :entity.type/metabase-dashboard (:metabase-dashboard/label entity)
        :entity.type/lp-news-category (or (:lp-news-category/display-name entity)
                                          (:lp-news-category/source-name entity))
        :entity.type/lp-news-type (or (:lp-news-type/display-name entity)
                                      (:lp-news-type/source-name entity))
        :entity.type/pre-investment-check (pre-investment-check/status-label (get entity :pre-investment-check/status))
        :entity.type/pre-exit-check (pre-exit-check/status-label (get entity :pre-exit-check/status))
        :entity.type/investment-reservation-type (:investment-reservation-type/title entity)
        :entity.type/survey-profile (let [target-id (:survey-profile/target entity)
                                          target (entity-lookup target-id)
                                          target-name (entity-name entity-lookup tr target)]
                                      (if target-name
                                        (str target-name "'s " (tr :entity.type/survey-profile))
                                        (tr :entity.type/survey-profile)))
        :entity.type/project-counterparty-diligence (:project-counterparty-diligence/project-name entity)
        :entity.type/company-counterparty-diligence (:company-counterparty-diligence/company-name entity)
        :entity.type/person-counterparty-diligence (:person-counterparty-diligence/person-name entity)
        :entity.type/aifm-decision (tr e-type)
        :entity.type/aifm-exit-decision (tr e-type)
        :entity.type/ic-decision (tr e-type)
        :entity.type/ic-exit-decision (tr e-type)
        :entity.type/advisory-board-decision (tr e-type)
        :entity.type/pm-approval-decision (tr e-type)
        :entity.type/decision-condition (:decision-condition/title entity)
        :entity.type/attestation-condition (:attestation-condition/title entity)
        :entity.type/decision-participant (let [person-id (:decision-participant/person entity)
                                                person (entity-lookup person-id)]
                                            (entity-name entity-lookup tr person))
        :entity.type/survey-question-option (let [translations (:survey-question-option/label-translations entity)
                                                  translations-map (if (string? translations)
                                                                     (data-types/parse-edn-string translations)
                                                                     translations)]
                                              (or (:ENG translations-map)
                                                  (val (first translations-map))))
        ;; TODO: Hack(??) we pass {:db/id 1 :value 1 :label "xyz"} from open search results as temp optimistic value
        (if-let [label (:label entity)]
          label
          (str e-type))))))
